/**
 * Created by shiyonggao on 2019/2/25.
 */

const handler = {
    _getUrl(rootState) {
        let url = rootState.$config.api.app.baseinfo;
        return _.replace(url, '{game_code}', rootState.$helper.helper.getGameCode().game_code);
    }
};

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    gameInfo: [],
    allSdkTye: [
        {
            value: 0,
            label: '常规SDK',
        },
        {
            value: 1,
            label: 'DD SDK',
        }
    ],
    demoStatus: false,
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_GAME_INFO_ACTIONS({state, commit, dispatch, rootState}, args) {

        let url = handler._getUrl(rootState);
        let options = [{'url': url, data: {}, method: 'get', 'key': 'gameInfo'}, {
            'url': '/available-s2s-proxies',
            data: {},
            method: 'get',
            'key': 's2s'
        }];

        rootState.$helper.request.all(options,
        (data) => {
            console.log(data);
            let ret = data['gameInfo'].data.game;
            let language = '';
            _.forEach(ret.lang, function (value, key) {
                language += ' ' + value.name;
            });
            let s2sData = data['s2s'].data.proxies;
            let s2sName = '';
            _.forEach(s2sData, function (value, key) {

                if (value.proxy_id == ret.proxy_id) {
                    s2sName = value.proxy_name;
                }
            });
            let sdkTypeName = (typeof (state.allSdkTye[ret.is_ddsdk])) ? state.allSdkTye[ret.is_ddsdk].label : '';
            console.log(sdkTypeName);

            data = {
                game_product: ret.family_detail.name,
                language: language,
                game_show_name_cn: ret.name,
                game_name: ret.local_name,
                gameCode: ret.game_code,
                mdataId: ret.mdata_app_id,
                gaId: ret.ga_account_id,
                fbAppId: ret.facebook_app_id,
                fbAppUrl: ret.facebook_app_url,
                googleDownLoadUrl: ret.google_download_url,
                iosDownLoadUrl: ret.ios_download_url,
                windowsDownLoadUrl: ret.windows_download_url,
                localDownLoadUrl: ret.local_download_url,
                commonUrl: ret.common_download_url,
                s2sAgent: ret.proxy_id,
                sdkType: ret.is_ddsdk,
                's2sName': s2sName,
                's2sData': s2sData,
                'sdkTypeName': sdkTypeName
            };
            commit('_updateGameInfo', data);
        },
        (res) => {
            // dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    UPDATE_GAME_INFO_ACTION({state, commit, dispatch, rootState}, args) {
        let url = handler._getUrl(rootState);
        rootState.$helper.request.put(url, args)
        .then(() => {
            dispatch('GET_GAME_INFO_ACTIONS', {args:1});

        })
        .catch((res) => {
            // dispatch('ERROR_HANDLE', res, {root: true});
        });
    },

};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {
    GET_DEMO_GETTER(state, getters) {
        let data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;

    },

    getDemoGetterOthr(state, getters) {
        return [{id: 4, data: 'aata4'}];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _updateGameInfo(state, args) {
        state.gameInfo = args;
    },

    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/gameConfig/baseInfo.js